import axios from "axios";
import { toast } from "react-toastify";
import companyAuthHeader from "./companyAuthHeader";

export const getAllUsers = (filter) => {
  return axios
    .get(
      `${process.env.REACT_APP_BASE_URL}/users`,
      {
        params: filter,
        headers: companyAuthHeader(),
      }
    )
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};

export const getUser = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/users/${id}`, {
      headers: companyAuthHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};

export const createUser = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/users`, data, {
        headers: companyAuthHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const updateUser = (data, id) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`${process.env.REACT_APP_BASE_URL}/users/${id}`, data, {
        headers: companyAuthHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const deleteUser = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(`${process.env.REACT_APP_BASE_URL}/users/${id}`, {
        headers: companyAuthHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

